import React, { useState, useEffect } from 'react';
import AvatarCustomizer from '@/components/avatar/AvatarCustomizer';
import FinalizeAvatar from '@/components/avatar/FinalizeAvatar';
import Disclaimer from '@/components/live/Disclaimer';
import UsernameSelector from '@/components/live/Username';
import { CustomizeStep, getRandomAvatar } from '@/components/avatar/constants.mjs';
import Page from '@/components/layout/Page';
import { useRouter } from "next/router";
import { usePlayer } from '@/lib/usePlayer';
import { fetchGeneratedUsername } from '@/lib/useGeneratedUsername';

const UserSettingsPage = () => {
	const { isLoading, isSuccess, data: player } = usePlayer();
	const router = useRouter();
	return (
		<Page pageTitle={'Profile'}>
			{ (isSuccess) ? <CustomizeLiveProfile player={player} onSave={() => { router.push('/')}}/> : <div>Loading...</div> }
		</Page>
	)
}

export default UserSettingsPage

export const CustomizeLiveProfile = ({ player, onSave }) => {
	const [customizeStep, setCustomizeStep] = useState(CustomizeStep.USERNAME);

	const [username, setUsername] = useState(player?.username ? player.username : '');
	// This is going to default to something random? Or pull from the user's profile?
	const [avatarState, setAvatarState] = useState(player?.avatar ? player.avatar : getRandomAvatar());

	useEffect(() => {
		if(player?.username) {
			setUsername(player.username);
		}
		if(player?.avatar) {
			setAvatarState(player.avatar);
		}
		const pattern = /\bPlayer-\d{1,6}\b/;
		if(!player?.username || username.match(pattern)) {
			getNewName()
		}
	}, []);

	const getNewName = async () => {
		const name = await fetchGeneratedUsername();
		setUsername(name);
	};

	const renderCustomizeStep = () => {
		switch (customizeStep) {
			case CustomizeStep.USERNAME:
				return <UsernameSelector 
					username={username} 
					setUsername={(data) => setUsername(data)}
					setState={(data) => setCustomizeStep(data)}
					state={customizeStep}
				/>;
			case CustomizeStep.CUSTOMIZE:
				return <AvatarCustomizer 
					setState={(data) => setCustomizeStep(data)} 
					state={customizeStep} 
					avatarState={avatarState} 
					setAvatarState={(data) => setAvatarState(data)}
				/>;
			case CustomizeStep.FINALIZE:
				return <FinalizeAvatar 
					setState={(data) => setCustomizeStep(data)} 
					state={customizeStep}
					setAvatarState={(data) => setAvatarState(data)}
					avatarState={avatarState}
					username={username}
					player={player}
					onSave={onSave}
				/>;
			case CustomizeStep.DISCLAIMER:
				return <Disclaimer setState={(data) => setCustomizeStep(data)} state={customizeStep}/>;
			default:
				return <div>Something went wrong in the customize step...</div>
		}
	}

	return (
		<div className={'mt-auto mb-auto'}>
			{renderCustomizeStep()}
		</div>
	)

}
